import { LeftOutlined } from "@ant-design/icons";
import {
  Button,
  Drawer,
  Form,
  Image,
  message,
  Modal,
  Space,
  Tag,
  Typography,
} from "antd";
import React, { useContext, useEffect, useRef } from "react";
import {
  getLatestNutritionRiskAssessmentAPI,
  getNutritionistInspectionAPI,
  getNutritionistRiskAssessmentAPI,
  nutritionistRiskAssessmentAPI,
  updateNutritionistRiskAssessmentAPI,
} from "../../../../services/nutritionist.services";
import { useLocation } from "react-router-dom";
import { RiskAssessmentContext } from "./RiskAssessmentFormProvider";
import NutritionistRiskAssessmentForm from "../../InspectionForms/DietAdvice/NutritionistRiskAssessmentForm";
import bedImg from "../../../../assets/images/patientIcons/bed.svg";
import "../../Doctor/InitialInspection/InitialInspectionHeader.css";
import "../../Doctor/DailyReview/DailyReview.css";

const RiskAssessmentForm = ({
  editId,
  visible,
  setVisible,
  refreshPage,
  addMode,
  setAddMode,
  setActiveSegment,
  riskAssessment,
  riskAssessmentRefresh,
  riskRefresh,
  segmentData,
  patientData,
  iAssessment,
}) => {
  const location = useLocation();
  const params = Object.fromEntries(new URLSearchParams(location?.search));
  const [riskForm] = Form.useForm();
  const { formData, setFormData } = useContext(RiskAssessmentContext);
  const newReview = riskAssessment?.length === 0;
  const reviewId = riskAssessment?.[0]?.id;
  const newReviewId = addMode === false && reviewId ? reviewId : null;
  const reviewDate =
    segmentData?.find(
      (option) => option.value === editId && option.value !== "others"
    )?.label ||
    new Date().toLocaleDateString("en-US", { month: "short", day: "2-digit" });

  const formBodyRef = useRef(null);

  const handleSubmit = async (values) => {
    try {
      if (editId || newReviewId) {
        await updateNutritionistRiskAssessmentAPI(editId || newReviewId, {
          ...values,
          diet_type:
            values?.functional_diagnosis?.diet_details?.diet ??
            formData?.functional_diagnosis?.diet_details?.diet,
        });
        riskAssessmentRefresh();
      } else {
        await nutritionistRiskAssessmentAPI({
          ...values,
          diet_type:
            values?.functional_diagnosis?.diet_details?.diet ??
            formData?.functional_diagnosis?.diet_details?.diet,
        });
        refreshPage();
        setAddMode(false);
        riskAssessmentRefresh();
      }

      message.success("Risk Assessment submitted successfully");

      //   setIsDirty(false);
    } catch (error) {
      message.error(error?.response?.data?.message || "Something went wrong");
      console.log("Error", error);
    }
  };

  const onRiskSubmit = (values) => {
    // console.log(values);
    const { bmi, ...rest } = values;
    const functionalDiagnosis = {
      ...rest,
      ...(bmi?.bmi_value && !isNaN(bmi.bmi_value) ? { bmi } : {}),
    };
    handleSubmit({
      ...formData,
      functional_diagnosis: functionalDiagnosis,
      admission_id: params?.patient,
    });
  };

  const openEdit = async () => {
    if (editId && newReview === false) {
      try {
        const response = await getNutritionistRiskAssessmentAPI(editId);
        setFormData(response.data.data);
      } catch (error) {
        console.log(`Error: ${error}`);
        message.error("Unable to Fetch Data");
      }
    } else if (newReview === false) {
      try {
        const response = await getLatestNutritionRiskAssessmentAPI(
          params?.patient
        );
        setFormData(response.data.data);
      } catch (error) {
        console.log(`Error: ${error}`);
        message.error("Unable to Fetch Data");
      }
    } else if (iAssessment) {
      try {
        const response = await getNutritionistInspectionAPI(iAssessment);
        setFormData(response.data.data);
      } catch (error) {
        console.log(`Error:${error}`);
      }
    }
  };

  useEffect(() => {
    openEdit();
  }, [editId, riskRefresh]);

  return (
    <div>
      <Drawer
        open={visible}
        width="100%"
        styles={{
          body: {
            overflow: "hidden",
            paddingTop: 0,
            paddingBottom: 0,
            paddingInline: 24,
            display: "flex",
            flexDirection: "column",
            height: "100%",
          },
        }}
        title={
          <div className="ia-drawer-header">
            <div className="ia-drawer-header__main">
              <LeftOutlined
                className="ia-drawer-header__back"
                onClick={() => {
                  Modal.confirm({
                    title: "Confirmation",
                    content: "Are you sure you want to close?",
                    onOk: () => {
                      setVisible(false);
                      setActiveSegment(riskAssessment?.[0]?.id);
                    },
                  });
                }}
              />
              <div className="ia-drawer-header__identity">
                <div className="ia-drawer-header__name-row">
                  <Typography
                    className="ia-drawer-header__name"
                    ellipsis={{
                      tooltip: `${patientData?.admission?.patient?.first_name || ""} ${
                        patientData?.admission?.patient?.last_name || ""
                      }`,
                    }}
                  >
                    {`${patientData?.admission?.patient?.first_name || ""} ${
                      patientData?.admission?.patient?.last_name || ""
                    }`.trim()}
                  </Typography>
                  {patientData?.admission?.bed?.bed_no && (
                    <Tag color="orange" className="ia-drawer-header__bed">
                      <Image src={bedImg} preview={false} width={12} />{" "}
                      {patientData?.admission?.bed?.bed_no}
                    </Tag>
                  )}
                </div>

                <div className="ia-drawer-header__meta">
                  <Tag className="ia-drawer-header__tag">
                    {patientData?.admission?.patient?.age_by_dob ||
                      patientData?.admission?.patient?.age}{" "}
                    {patientData?.admission?.patient?.gender}
                  </Tag>
                  <Tag className="ia-drawer-header__tag">
                    IP ID: {patientData?.admission?.ip_id}
                  </Tag>
                  {formData?.submitted_by_first_name && (
                    <Tag className="ia-drawer-header__tag">
                      Done by: {formData?.submitted_by_first_name}{" "}
                      {formData?.submitted_by_last_name || ""}
                    </Tag>
                  )}
                  {reviewDate && (
                    <Tag className="ia-drawer-header__tag">{reviewDate}</Tag>
                  )}
                </div>
              </div>
            </div>
          </div>
        }
        footer={null}
        onClose={() => {
          setVisible(false);
          setActiveSegment(riskAssessment?.[0]?.id);
        }}
        closeIcon={null}
        keyboard={false}
      >
        <div className="daily-review-form-shell">
          <div className="ia-form-panel">
            <div className="ia-form-body" ref={formBodyRef}>
              <Form
                id="nutrition-risk-assessment"
                form={riskForm}
                layout="vertical"
                onFinish={onRiskSubmit}
                initialValues={formData}
                className="ip-forms ip-forms-review nutrition-risk-assessment-form"
              >
                <NutritionistRiskAssessmentForm
                  form={riskForm}
                  patientData={patientData}
                />
              </Form>
            </div>

            <div className="ia-form-footer">
              <Button
                onClick={() => {
                  riskForm.submit();
                  setVisible(false);
                }}
                type="primary"
                className={""}
              >
                Done
              </Button>
            </div>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default RiskAssessmentForm;
